export function blobToDataURL(blob: Blob): Promise<string> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();

		reader.onload = function () {
			if (typeof reader.result === 'string') {
				resolve(reader.result);
			} else {
				reject(new Error('Failed to read blob as a data URL'));
			}
		};
		reader.onerror = function () {
			reject(reader.error ?? new Error('Failed to read blob as a data URL'));
		};
		reader.readAsDataURL(blob);
	});
}
